import { ReactComponent as ArrowBack } from "./arrowBack_icon.svg"
import { ReactComponent as ArrowForward } from "./arrowForward_icon.svg"
import { ReactComponent as Check } from "./check_icon.svg"
import { ReactComponent as SBPIcon } from "./sbp_icon.svg"
import { ReactComponent as Pay } from "./pay_icon.svg"
import { ReactComponent as Replenish } from "./replenish_icon.svg"
import { ReactComponent as Send } from "./send_icon.svg"
import { ReactComponent as Search } from "./search_icon.svg"
import { ReactComponent as ArrowUp } from "./arrowUp_icon.svg"
import { ReactComponent as ArrowDown } from "./arrowDown_icon.svg"
import { ReactComponent as AwaitTransfer } from "./await_send_icon.svg"
import { ReactComponent as ErrorTransfer } from "./send_error_icon.svg"
import { ReactComponent as BrandPay } from "./brandPay_icon.svg"
import { ReactComponent as SBPExtendedIcon } from "./sbpExtended_icon.svg"
import { ReactComponent as CheckYellow } from "./check_yellow_icon.svg"
import { ReactComponent as Account } from "./account_icon.svg"
import { ReactComponent as Backspace } from "./backspace_icon.svg"
import { ReactComponent as Calendar } from "./calendar_icon.svg"
import { ReactComponent as IconBox } from "./iconBox_icon.svg"
import { ReactComponent as BPTransfer } from "./brandPayTransfer_icon.svg"
import { ReactComponent as CreditCard } from "./creditCard_icon.svg"
import { ReactComponent as SBPBox } from "./sbpBox_icon.svg"
import { ReactComponent as Close } from "./close_icon.svg"
import { ReactComponent as CloseBox } from "./closeBox_icon.svg"
import { ReactComponent as DocsBox } from "./docsBox_icon.svg"
import { ReactComponent as TouchID } from "./touchID_icon.svg"
import { ReactComponent as SettingsIcon } from "./settings_icon.svg"
import { ReactComponent as InfoIcon } from "./info_icon.svg"
import { ReactComponent as PasswordIcon } from "./password_icon.svg"
import { ReactComponent as PlusIcon } from "./plus_icon.svg"
import { ReactComponent as PhoneIcon } from "./phone_Icon.svg"
import { ReactComponent as BeelineProfile } from "./beeline_profile.svg"
import { ReactComponent as CheckMark } from "./check_mark.svg"
import { ReactComponent as AlertIcon } from "./alert.svg"
import { ReactComponent as GlobalError } from "./globalError_icon.svg"
import { ReactComponent as ShoppingBugIcon } from "./shoppingBag_icon.svg"
import { ReactComponent as IncomeGreyIcon } from "./incomeGrey_icon.svg"
import { ReactComponent as OutcomeGreyIcon } from "./outcomeGrey_icon.svg"
import { ReactComponent as IncomeYellowIcon } from "./incomeYellow_icon.svg"
import { ReactComponent as OutcomeYellowIcon } from "./outcomeYellow_icon.svg"
import { ReactComponent as LimitsIcon } from "./limits_icon.svg"
import { ReactComponent as FRFIcon } from "./f-rf.svg"
import { ReactComponent as MBankIcon } from "./mb.svg"
import { ReactComponent as W1Icon } from "./w1.svg"
import { ReactComponent as RusBankIcon } from "./bank_rus_icon.svg"
import { ReactComponent as QRCodeIcon } from "./qr.svg"

export const icons = {
  limitsIcon: LimitsIcon,
  phoneIcon: PhoneIcon,
  arrowBack: ArrowBack,
  arrowForward: ArrowForward,
  check: Check,
  sbpIcon: SBPIcon,
  pay: Pay,
  replenish: Replenish,
  send: Send,
  search: Search,
  arrowUp: ArrowUp,
  arrowDown: ArrowDown,
  waitTransfer: AwaitTransfer,
  errorTransfer: ErrorTransfer,
  brandPay: BrandPay,
  sbpExtIcon: SBPExtendedIcon,
  checkYellow: CheckYellow,
  account: Account,
  backspace: Backspace,
  calendar: Calendar,
  iconBox: IconBox,
  bpTransfer: BPTransfer,
  creditCard: CreditCard,
  sbpBox: SBPBox,
  close: Close,
  closeBox: CloseBox,
  docsBox: DocsBox,
  touchID: TouchID,
  settingsIcon: SettingsIcon,
  infoIcon: InfoIcon,
  passwordIcon: PasswordIcon,
  plusIcon: PlusIcon,
  beelineProfile: BeelineProfile,
  checkMark: CheckMark,
  alertIcon: AlertIcon,
  globalErrorIcon: GlobalError,
  shoppingBag: ShoppingBugIcon,
  outcomeGrey: OutcomeGreyIcon,
  incomeGrey: IncomeGreyIcon,
  outcomeYellow: OutcomeYellowIcon,
  incomeYellow: IncomeYellowIcon,
  frfIcon: FRFIcon,
  mbankIcon: MBankIcon,
  w1Icon: W1Icon,
  rusBankIcon: RusBankIcon,
  qrCodeIcon: QRCodeIcon,
}
